module.exports = __webpack_public_path__ + "static/media/meh-rolling-eyes.95b5c0e0.svg";